export default __webpack_public_path__ + "static/tutorial-img1-f6f40192322e9298477fe861af048961.svg";